/**
 * E101.F3 (ADR-0085 §2.4) — o que a página de assinaturas e a captura da biometria do dossiê em
 * imagem dizem da biometria e o formulário não edita: a transação que a assinatura declara e a
 * captura do painel (instante, decisão, base, código de resposta).
 *
 * Volta intacto no "Salvar", porque o servidor substitui o protocolo inteiro (a lição da E84.F9).
 * Só os campos presentes: a ida e volta de um protocolo sem eles não inventa `null`.
 */
import type { BiometriaProtocoloData } from '@/lib/exame_eletronico';

const CAMPOS_DO_DOSSIE = [
  'transacao_na_assinatura',
  'capturada_em',
  'capturada_em_fuso_presumido',
  'autorizada',
  'base_consultada',
  'codigo_de_resposta',
] as const;

export type BiometriaDoDossie = Pick<BiometriaProtocoloData, (typeof CAMPOS_DO_DOSSIE)[number]>;

export function biometriaDoDossie(biometria: BiometriaProtocoloData): BiometriaDoDossie {
  const lidos: Record<string, unknown> = {};
  for (const campo of CAMPOS_DO_DOSSIE) {
    if (biometria[campo] !== undefined) lidos[campo] = biometria[campo];
  }
  return lidos as BiometriaDoDossie;
}
